import { render, staticRenderFns } from "./task-type-calc.vue?vue&type=template&id=708318a2&scoped=true"
import script from "./task-type-calc.vue?vue&type=script&lang=js"
export * from "./task-type-calc.vue?vue&type=script&lang=js"
import style0 from "./task-type-calc.vue?vue&type=style&index=0&id=708318a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708318a2",
  null
  
)

export default component.exports